import { render } from "./CollectCallQueueTable.vue?vue&type=template&id=46ed123a"
import script from "./CollectCallQueueTable.vue?vue&type=script&lang=js"
export * from "./CollectCallQueueTable.vue?vue&type=script&lang=js"

import "./CollectCallQueueTable.vue?vue&type=style&index=0&id=46ed123a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__